<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <b-card>
          <b-card-text>
            <b-form-group label="Fecha" label-for="fecha">
              <b-datepicker v-model="hoy"></b-datepicker>
            </b-form-group>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="url != null">
      <b-col sm="12">
        <iframe :src="url" style="width: 100%; height: 800px; border: none;">
          No fue posible cargar el pdf
        </iframe>
      </b-col>
    </b-row>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { fdc } from "@/helpers/fabricadecodigo"

export default {
  name: "diario",
  page: {
    title: "Reporte Diario",
    meta: [{ name: "diario", content: appConfig.description}]
  },
  components: {
    Layout, PageHeader,
  },
  watch: {
    hoy: function(value) {
      this.url = null
      this.url = fdc.getHost("/reportes/diario/" + this.token + "/" + value)
    }
  },
  data() {
    return {
      title: "Reporte Diario",
      items: [ { text: "Principal", href: "/"}, { text: "Reportabilidad "}, { text: "Reporte Diario", active: true }],
      hoy: null, token: null, url: null
    }
  },
  mounted() {
    const usuario = JSON.parse(localStorage.getItem("user"));
    this.token = usuario.token
    this.hoy = this._getHoy()
  },
  methods: {
    _getHoy() {
      const hoy = new Date();
      return hoy.getFullYear() + "-" + this.leadingZeros(hoy.getMonth() + 1,2) + "-" + this.leadingZeros(hoy.getDate(), 2)
    },
    leadingZeros(valor, tamano)  {
      tamano = (tamano === undefined) ? 2 : tamano
      var s = "000000000000000000000" + valor;
      return s.substring(s.length-tamano)
    },
  }
}
</script>

<style scoped>

</style>
